// import NProgress from 'nprogress'
// import 'nprogress/nprogress.css'
import { getToken } from '@/utils/auth'
import { isHttp } from '@/utils/validate'
import { isRelogin } from '@/utils/request'
import useUserStore from '@/store/modules/user'
import usePermissionStore from '@/store/modules/permission'
import useAppStore from '@/store/modules/app'
import { eui } from 'ems-ui'


// NProgress.configure({ showSpinner: false });

const whiteList = ['/login', '/auth-redirect', '/bind', '/register'];

/** 这些站级路由必须带 stationId，否则顶部站级头部不渲染、页面接口会带空 ID */
const needStationIdPaths = [
  '/station-monitor/detail',
  '/business-operations/detail',
  '/it-operations/detail',
]

/**
 * 站级路由缺少 stationId 时，在导航完成前补齐。
 * 放在守卫里而非页面组件里，是为了让 Navbar 首帧就能拿到 query.stationId，
 * 否则顶部头部要等到 router-view 内部组件回填后才挂载，明显晚于页面主体。
 * @returns {object|null} 需要重定向时返回目标路由，否则 null
 */
async function resolveStationId(to) {
  if (!needStationIdPaths.includes(to.path)) return null
  if (to.query.stationId) return null

  const appStore = useAppStore()
  // 持久化的 stationId / stations 命中时全程同步，不产生额外延迟
  let id = appStore.stationId || appStore.stations?.[0]?.stationId
  if (!id) {
    await appStore.getStations()
    id = appStore.stationId || appStore.stations?.[0]?.stationId
  }
  // 账号无任何电站：不重定向，交给页面自行降级
  if (!id) return null

  return { path: to.path, query: { ...to.query, stationId: String(id) }, replace: true }
}


/**
 * 设置权限
 * @param {import('vue-router').Router} router 
 */
export function setPremission(router) {
  
  const userStore = useUserStore()
  const permissionStore = usePermissionStore()

  router.beforeEach(async (to, from, next) => {
    // NProgress.start()
    const token = getToken()
    if (token) {
      /* has token*/
      if (to.path === '/login') {
        next({ path: '/' })
        // NProgress.done()
      }
      else {
        // 判断当前用户是否已拉取完user_info信息
        if (userStore.roles.length === 0 || !userStore.userId || userStore.token !== token) {
          isRelogin.show = true
          try {
            userStore.token = token
            await userStore.getInfo()
            isRelogin.show = false
            // const accessRoutes = await permissionStore.generateRoutes()
            // // 根据roles权限生成可访问的路由表
            // accessRoutes.forEach(route => {
            //   if (!isHttp(route.path)) {
            //     // 动态添加可访问路由表
            //     router.addRoute(route)
            //   }
            // })
            // 当前未动态 addRoute，直接放行避免首次进入时重复导航导致接口请求翻倍
            next(await resolveStationId(to) || undefined)

          } catch (err) {
            console.error(err);
            eui.showToast(err.message, 'error')
            await userStore.logOutWithoutAPI()
            setTimeout(() => {
              next({ path: '/login' })
            }, 500);
          }
        } else {
          next(await resolveStationId(to) || undefined)
        }
      }
    }
    else {
      // 没有token
      if (whiteList.indexOf(to.path) !== -1) {
        // 在免登录白名单，直接进入
        next()
      } else {
        next(`/login?redirect=${to.fullPath}`) // 否则全部重定向到登录页
        // NProgress.done()
      }
    }
  })

  router.afterEach(() => {
    // NProgress.done()
  })
}
